module.exports = __webpack_public_path__ + "img/methodical-organizer.281db9f8.png";